var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn btn-light btn-sm font-weight-bolder btn-upper btn-text",on:{"click":function($event){return _vm.$emit('button-clicked')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }